module.exports = __webpack_public_path__ + "img/logoE015.76e161a1.jpg";